<template>
  <div class="">
    <vue-html2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="yes"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-content-width="PageWidth"
      :pagebreak="PageBreak"
      :pdf-orientation="LayoutStyle"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2pdf"
    >
      <section slot="pdf-content">
        <div id="PDFContainer">
          <section
            style="margin-left: 1rem; text-align:center;"
            v-if="this.$PDFType == 'WaterTest'"
          >
            <TestResultsModal> </TestResultsModal>
          </section>
          <section v-if="this.$PDFType != 'WaterTest'">
            <RiskAssess> </RiskAssess>
          </section>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
// import axios from "axios";
import {} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import TestResultsModal from "../components/PDF Components/TestResultsModal.vue";
import RiskAssess from "../components/PDF Components/RiskAssessPDF.vue";

export default {
  components: {
    VueHtml2pdf,
    TestResultsModal,
    RiskAssess,
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // orientation: "landscape",

        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },
  },
  data() {
    return {
      LayoutStyle: this.Orientation(),
      PageBreak: {
        mode: "legacy",
      },
      PageWidth: "",
    };
  },
  mounted() {
    this.$refs.html2pdf.generatePdf();
  },
  methods: {
    Orientation() {
      if (this.$PDFType == "WaterTest") {
        this.PageWidth = "1080px";
        return "Landscape";
      } else {
        this.PageWidth = "";

        return "Portrait";
      }
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {},
  },
};
</script>
<style></style>
